const getStoredSettingsPage = () => {
  if (typeof window === "undefined") return "staff";
  return window.localStorage.getItem("settingsActiveTab") || "staff";
};

export const initialState = {
  auth: {
    userData: {
      services: [],
      selectedServiceId: null,
    },
    // apiKey: null,
    accessToken: null,
    refreshToken: null,
    isLoggedIn: false,
    isRefreshing: false,
    isLoading: false,
    error: null,
    GoogleError: null,
    allowRegistrationForm: false,
    allowThanksForRegistrationPage: false,
  },

  video: {
    cameras: [],
    isCameraLoading: null,
    errorCamera: null,
  },

  cars: {
    current: [],
    day: [],
    records: [],
    newCars: [],
    paymentStatistic: {},
    periodCars: [],
    forHours: {},
    monthlyLoad: {},
    date: new Date().toISOString().substring(0, 10),
    isLoading: false,
    error: null,
    booking: [],
    loadPercent: null,
    queryMonth: null,
    workHours: {},
    workHoursForCurrentDay: {},
    lastSetDate: null,
    isLoadingForCalendar: false,
    isLoadingCarsByDay: false,
    isCurrentCarsLoading: false,
    isPaymentStatisticLoading: false,
    statistics: {},
    selectedMonth: new Date().toISOString().substring(0, 7),
  },

  crm: {
    serviceData: {
      mechanics: [],
      posts: [],
      services: [],
      workingHours: [],
      availability: [],
    },
    // records: [],
    // dayRecords: [],
    record: {},
    dates: {
      startDate: null,
      endDate: null,
    },
    visits: [],
    load: [],
    carDataByPlate: {},
    isLoading: false,
    error: null,
    isServiceDataLoading: false,
    isCarByPlateLoading: false,
  },

  clients: {
    clientsList: [],
    clientInfo: {
      client: {},
      car: {},
      client_cars: [],
      service_history: [],
      repair_id: null,
    },
    carWithoutClient: {},
    carWithoutClientLoading: null,
    clientsListLoading: null,
    isLoading: null,
    error: null,
    carRepairHistory: [],
    roadmapHistory: [],
    roadmapHistoryLoading: false,
  },

  service: {
    services: [],
    tariffsInfo: {},
    tariffsModalOpen: false,
    // Дні до видалення акаунта, якщо тариф не активний (null - повідомлення не показуємо)
    inactiveTariffDays: null,
    legalEntities: [],
    particularService: {},
    selectedServiceInSettingsId: null,
    isLoading: false,
    isCheckTariffsLoading: false,
    error: null,
  },

  settings: {
    employees: [],
    mechanics: [],
    employeeFormData: {},
    permissionsList: [],
    permissionsByRole: [],
    suppliers: [],
    supplierWarehouses: {},
    schedule: [],
    posts: [],
    partsPrices: [],
    otherServicesPrices: [],
    isUploadingOtherServicesPrices: false,
    isUploadingPartsPrices: false,
    pricesForDiagnostic: [],
    editedServices: [],
    // categoryPrices: [],
    markups: [],
    cashRegisters: [],
    isCashRegistersLoading: false,
    integration: {},
    license: {},
    licenseRequest: {}, 
    isLoading: false,
    isStaffUpdating: false,
    error: null,
    isTestingSupplierConnection: false,
    tutorialSection: "",
    settingsPage: getStoredSettingsPage(),
    finishedPages: [],
    legalPersonType: "ФОП",
    isServiceAccordionExpanded: false,
    isTutorialOpen: false,
    tutorialNavigation: [
      {
        page: "Налаштування",
        id: "1",
        done: false,
        sections: [
          // { name: "Вся сторінка", id: "whole-page" },
          { name: "Список сервісів", id: "services" },
          // { name: "Створення сервісу", id: "create-service" },
          { name: "Налаштування робочого графіка", id: "schedule" },
          { name: "Налаштування постачальників", id: "suppliers" },
          { name: "Налаштування постів", id: "posts" },
          { name: "Налаштування персоналу", id: "staff" },
          { name: "Налаштування прайсу", id: "price" },
          { name: "Налаштування складу", id: "warehouse" },
          { name: "Налаштування кас", id: "cashRegisters" },
        ],
        name: "settings",
      },
      {
        page: "Моніторинг",
        id: "2",
        done: false,
        name: "video-control",
        sections: [
          { name: "Статистика", id: "statistic" },
          { name: "Камери", id: "cameras" },
          { name: "Графік машинозаїздів", id: "cars-chart" },
          { name: "Графік завантаженості сервісу", id: "service-load-chart" },
          { name: "Авто в роботі", id: "cars-in-work" },
        ],
      },
      {
        page: "Планувальник",
        id: "3",
        done: false,
        name: "crm",
        sections: [
          { name: "Планувальник", id: "planner" },
          { name: "Селектор часового періоду", id: "period-selector" },
          { name: "Список авто", id: "cars-list" },
          { name: "Створення запису", id: "create-record" },
        ],
      },
      {
        page: "В роботі",
        id: "4",
        done: false,
        name: "accounting/clients",
        sections: [
          { name: "Загальна інформація про сторінку", id: "general-info" },
          { name: "Інформація по клієнту", id: "clientInfo-modal" },
          {
            name: "Запис",
            id: "appointment-modal",
          },
          { name: "Діагностика", id: "diag-modal" },
          {
            name: "КП (комерційна пропозиція)",
            id: "co-modal",
          },
          { name: "Аванс", id: "prepayment-modal" },
          { name: "Замовлення", id: "order-modal" },
          { name: "Надходження товару", id: "received-modal" },
          { name: "Ремонт", id: "repair-modal" },
          { name: "Оплата клієнта", id: "client-payment-modal" },
          { name: "Нагадування", id: "notification-modal" },
        ],
      },
      { page: "Облік", id: "5", done: false, name: "accounting" },
      { page: "Звіти", id: "6", done: false, name: "reports" },
    ],
  },

  warehouse: {
    warehouses: [],
    warehouse: {
      id: null,
      name: null,
      address: null,
      total_sections: null,
      parent: null,
      sections: [
        {
          id: null,
          name: null,
          total_racks: null,
          parent: {
            id: null,
            name: null,
            type: null,
          },
          racks: [
            {
              id: null,
              name: null,
              total_shelves: null,
              parent: {
                id: null,
                name: null,
                type: null,
              },
              shelves: [
                {
                  id: null,
                  name: null,
                  total_places: null,
                  parent: {
                    id: null,
                    name: null,
                    type: null,
                  },
                  places: [
                    {
                      id: null,
                      name: null,
                      parent: {
                        id: null,
                        name: null,
                        type: null,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    warehousesWithParts: [],
    warehousesWithPartsLoading: null,

    sections: [],
    racks: [],
    shelves: [],
    places: [],
    prompts: [],

    partsUploadHistory: [],
    partsUploadHistoryTotal: 0,
    partsUploadHistoryLoading: false,
    isLoading: false,
    error: null,
  },

  archive: {
    archiveData: [],
    reasons: [
      {
        id: 1,
        name: "duplicate",
      },
      {
        id: 2,
        name: "employee",
      },
      {
        id: 3,
        name: "random",
      },
      {
        id: 4,
        name: "refusal",
      },
      {
        id: 5,
        name: "no_show",
      },
      {
        id: 6,
        name: "rating",
      },
      {
        id: 7,
        name: "no_help",
      },
    ],
    currentArchiveStat: {},
    isLoading: false,
    error: null,
  },

  chat: {
    isChatOpen: false,
    channels: [],
    userInfo: [],
    tags: [],
    prompts: [],
    selectedPrompt: null,
    tickets: [],
  },

  connections: {
    stats: {},
    connectionsList: [],
    isLoading: false,
    error: null,
  },

  accounting: {
    stats: {},
    clientsList: [],
    recordInfo: {},
    diagnosticTree: {},
    partDetailsForDiagnostic: {},
    nodesAndPartsForDiagnostics: [],
    appeal: {},
    diagnostic: {},
    diagnosticId: null,
    bufferDiagnostic: {},
    commercialOfferData: {},
    commercialOffer: {},
    partOffersByOEM: [],
    additionalSearchParts: [],
    order: {},
    receiving: {},
    particularOrderBySupplier: {},
    partsSearchStatuses: {},
    repairDetails: {},
    invoices: {},
    error: null,
    carsListError: null,
    isLoading: null,
    isRecordInfoLoading: null,
    isCarsListLoading: null,
    isCOLoading: null,
    isPartOffersByOEMLoading: null,
    isDiagLoading: null,
    isDiagnosticTreeLoading: null,
    isBufferDiagnosticLoading: null,
    isPartDetailsForDiagnosticLoading: null,
    isDiagCreateLoading: null,
    isRepairLoading: null,
    isStatsLoading: false,
    isParticularOrderBySupplierLoading: null,
    chosenPeriod: {},
    chosenPartsInDiag: [],
    modalCarId: null,
    globalOfferObj: null,
    newPartInRepair: null,
    isAddingNewRow: false,
  },

  documents: {
    itemsDocs: {},
    paymentsDocs: {},
    searchQuery: "",
    detailedDoc: {},
    userCompaniesData: [],
    chosenLocationInWarehouse: null,
    secondChosenLocationInWarehouse: null,
    partsToDisplay: [],
    allParts: [],
    partsByLocation: [],
    chosenPeriod: {},
    ordersList: {},
    paymentsReturnBasis: [],
    locationsByPartId: {}, // { partId1: locationId1, partId2: locationId2, ... }
    salesList: [],
    saleListLoading: null,
    sale: {},
    receives: [],
    returnDoc: {},
    returnReasons: [],
    revaluationDoc: {},
    writeOffDoc: {},
    inventoryDoc: {},
    goodsTransferDoc: {},
    documentsByType: [],

    detailedDocLoading: null,
    itemsDocsLoading: null,
    paymentDocsLoading: null,
    userCompaniesDataLoading: null,
    partsToDisplayLoading: null,
    writeoffLoading: null,
    ordersListLoading: null,
    returnDocLoading: null,
    receiveLoading: null,
    returnPaymentsInfoLoading: null,
    documentsByTypeLoading: null,

    error: null,
  },

  reports: {
    balanceStats: {},
    workAndReadyList: [],
    suppliers: [],
    employees: [],
    warehousesStock: [],
    cashRegistersReport: [],
    balanceSalesReport: [],
    error: null,
    isLoading: null,
    isLoadingStats: false,

    suppliersStats: {},
    isSuppliersStatsLoading: false,
    notSoldReport: {},
    isNotSoldReportLoading: false,
    suppliersReport: [],
    isSuppliersReportLoading: false,

    clientsStats: {},
    clientsList: [],
    isClientsReportLoading: false,

    profitStats: {},
    profitPartsReport: [],
    profitWorksReport: [],
    profitOthersIncomeReport: [],
    mechanicSalaryReport: [],
    staffSalaryReport: [],
    taxesReport: [],
    expansesReport: [],
    profitStatsLoading: false,
    profitPartsLoading: false,
    profitWorksLoading: false,
    profitOthersIncomeLoading: false,
    mechanicSalaryReportLoading: false,
    staffSalaryReportLoading: false,
    taxesReportLoading: false,
    expansesReportLoading: false,

    warehousesStats: {},
    warehousesReport: [],
    warehousesReturns: [],
    warehousesDisposals: [],
    warehousesStatsLoading: false,
    warehousesReportLoading: false,
    warehousesReturnsLoading: false,
    warehousesDisposalsLoading: false,
  },

  payments: {
    createdPaymentInfo: null,
    cashTransfer: null,
    paymentTypes: [],
    isLoading: null,
    error: null,
  },

  tariffs: {
    listOfTariffs: [],
    invoiceData: {},
    tariffsLoading: null,
    invoiceDataLoading: null,
    balanceUsageDetails: [],
    balanceUsageDetailsLoading: null,
    error: null,
  },

  database: {
    databaseTree: {},
    error: null,
  },

  changeLog: {
    currentVersionChanges: {},
    isCHangeLogLoading: null,
    error: null,
  },

  notifications: {
    notificationsList: [],
    detailedNotification: null,
    unreadCount: 0,
    isLoading: null,
    error: null,
    toasts: [],
    isPopupOpen: false,
  },
};
